import React, { useState, useRef, useEffect } from 'react'
import './Header.css'
import { CgProfile } from 'react-icons/cg'
import { AiOutlineLogout } from 'react-icons/ai'
import { RiLockPasswordFill } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BranchMaster } from '../../../AllAPI/AdminAPI'
import hostelLogo from '../../../Assets/Logo2.png'

export default function Header({ toggleSidebar, onLogout }) {
  const UserName = sessionStorage.getItem('username')
  const UserRole = sessionStorage.getItem('role')
  const BranchId = sessionStorage.getItem('branch_id')
  const SelectedBranchId = sessionStorage.getItem('selected_branch')
  const [branchName, setBranchName] = useState('')

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()

  const toggleDropdown = (e) => {
    e.stopPropagation()
    setDropdownOpen((prev) => !prev)
  }

  //  Improved outside click detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  const handleLogoutClick = (e) => {
    e.stopPropagation()
    setShowLogoutModal(true)
    setDropdownOpen(false)
  }

  const confirmLogout = () => {
    setShowLogoutModal(false)
    onLogout()
    navigate('/admin/login')

    sessionStorage.clear()
    localStorage.clear()
  }

  const cancelLogout = () => setShowLogoutModal(false)

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        if (!SelectedBranchId) return

        // 2. API call
        const response = await axios.get(BranchMaster)

        // 3. Extract branches array (handles both formats)
        const branches = Array.isArray(response.data)
          ? response.data
          : response.data.data

        // 4. Find match
        const matched = branches.find(
          (item) => String(item.branch_id) === String(SelectedBranchId),
        )

        // 5. Set branch name if matched
        if (matched) {
          setBranchName(matched.branch_name)
        }
      } catch (error) {
        console.error('Error fetching branches:', error)
      }
    }

    fetchBranches()
  }, [])

  return (
    <>
      <header className="header shadow">
        {/* ===== Desktop ===== */}
        <div className="desktop-grid">
          {/* {UserRole !== 'office' ? (
            <button
              className="menu-btn"
              onClick={toggleSidebar}
              aria-label="menu"
            >
              ☰
            </button>
          ) : (
            <button className="border-0"> </button>
          )} */}


          <button
            className="menu-btn"
            onClick={toggleSidebar}
            aria-label="menu"
          >
            ☰
          </button>


          <div className="desktop-center">
            <span className="header-title">
              <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />
              {branchName || 'Digambar Jain Boarding Kolhapur'}
            </span>
          </div>

          <div className="profile-container" ref={dropdownRef}>
            <span style={{ color: '#fff' }}>
              Hi, {UserName?.toUpperCase()} &nbsp;
            </span>
            <CgProfile className="profile border" onClick={toggleDropdown} />
            {dropdownOpen && (
              <div className="profile-dropdown slide-in">
                {/* <button className="dropdown-item">
                <RiLockPasswordFill /> Change Password
              </button> */}
                <button className="dropdown-item" onClick={handleLogoutClick}>
                  <AiOutlineLogout /> Logout
                </button>

                <button
                  className="dropdown-item"
                  onClick={() => {
                    setDropdownOpen(false)
                    // navigate('/admin/change-pass')
                    navigate(`/${UserRole}/change-pass`)
                  }}
                >
                  <RiLockPasswordFill /> Change Password
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ===== Mobile ===== */}
        <div className="mobile-header">
          <div className="mobile-center">
            <span className="mobile-title">
              <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />{' '}
              {branchName || 'Digambar Jain Boarding Kolhapur'}
            </span>
          </div>

          <div className="mobile-bottom" ref={dropdownRef}>
            {/* {UserRole !== 'office' ? (
              <button className="menu-btn" onClick={toggleSidebar}>
                ☰
              </button>
            ) : (
              <button className="border-0"> </button>
            )} */}

            <button className="menu-btn" onClick={toggleSidebar}>
              ☰
            </button>


            <div className="profile-container">
              <span style={{ color: '#000' }}>
                Hi, {UserName?.toUpperCase()} &nbsp;
              </span>
              <CgProfile className="profile border" onClick={toggleDropdown} />
              {dropdownOpen && (
                <div className="profile-dropdown slide-in">
                  <button className="dropdown-item">
                    <RiLockPasswordFill /> Change Password
                  </button>
                  <button className="dropdown-item" onClick={handleLogoutClick}>
                    <AiOutlineLogout /> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* ===== Logout Confirmation ===== */}
      {showLogoutModal && (
        <>
          <div className="logout-overlay" onClick={cancelLogout}></div>
          <div className="logout-modal">
            <h2>Confirm Logout</h2>
            <p>Are you sure you want to logout?</p>
            <div className="modal-buttons">
              <button className="btn-cancel" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="btn-confirm" onClick={confirmLogout}>
                OK
              </button>
            </div>
          </div>
        </>
      )}
    </>
  )
}
